module.exports = __webpack_public_path__ + "static/beam-fire-image-header-8414d7ae36a4c6a55c30cab91bbc2f9a.jpg";